import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import spaghetti from "assets/img/spaghetti.jpg";
//import Ads5 from "../../Main/Sections/Ads5.js";
import {Helmet} from 'react-helmet'



import styles from "assets/jss/material-kit-react/views/spaghetti.js";
import { string } from "prop-types";

const useStyles = makeStyles(styles);

export default function TopDevMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );

    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Helmet>
    <title>کمپ آموزشی شریف | مسابقه برنامه نویسی کد نویسی مبهم (SOPC)</title>
    <meta name="description" content="مسابقه کد نویسی مبهم حضوری SOPC با هدف یافتن استعدادهای برنامه نویسی." />
 <meta name="" content="contest, programming,IOCCC,Spaghetti Code, SOPC,cpp,c++,برنامه نویسی، مسابقه برنامه نویسی"/>
  </Helmet>
            <Parallax small filter image={require("assets/img/bg5.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>

                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={spaghetti} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>مسابقات کد نویسی مبهم</h3>
                                        <div className={classes.description}>
                                            <p>
                                                مسابقات کد نویسی مبهم رویداد هایی در راستای تخمین مهارت شرکت کنندگان در نوشتن کد های ناخوانا یا در اصطلاح برنامه نویسان همان کد کثیف  (Dirty Code) است. یک برنامه را هنگامی ناخوانا می نامیم که اگر کد برنامه در اختیار برنامه نویس دیگر قرار دهیم و او معنای تک تک دستورات برنامه را بداند، شیوه کنار هم چیده شدن دستورات و پرش های تو در توی میان آنها به حدی پیچیده و گیج کننده باشد که برنامه نویس بدون اجرای این برنامه، نتواند تشخیص دهد که خروجی برنامه چیست؟
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                        {
        //<Ads2 />
      
      
      //<Ads5 />
      }

                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h4>هدف مسابقه</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        SOPC یک مسابقه برنامه‌ نویسی است. هدف از برگزاری این مسابقه صرفاً یک رقابت فنی بین افراد نیست، بلکه قرار است در این رویداد دانش و مهارت برنامه ‌نویسی شرکت ‌کنندگان افزایش یابد و مهارت و دانش کسب شده در صنعت فناوری اطلاعات کشور مورد استفاده قرار گیرد و شرکت کنندگان مسابقه بعد از این رویداد وارد بازار کار کشور شوند. به این منظور سعی کردیم مسابقه را به سمتی سوق دهیم که حداکثر تعداد مخاطبین را از جامعه‌ی فنی و برنامه ‌نویسان کشور داشته باشیم.
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h4>نحوه ورود به مسابقه</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        هر تیم برای شرکت در مسابقه باید به ناخوانا ترین شکل ممکن، برنامه ای به زبان c++ بنویسد که با هر بار اجرا شدن، رشته ای معین به طول حداقل یک و حداکثر سه کاراکتر را روی صفحه نمایش چاپ کند.
                                </p>
                                    <p>
                                        این رشته میبایست همواره ثابت باشد، نه آنکه در هر بار اجرا رشته ای متفاوت چاپ کند، و یا اینکه با انتقال به کامپیوتری دیگر، خروجی متفاوتی بدهد. تمام کاراکترهای این رشته باید روی صفحه کلید موجود و قابل تایپ باشند.
</p>
                                    <p>
                                        تیم ها می بایست کد های خود را تا یک هفته قبل از برگزاری رویداد برای تیم داوری ارسال کنند. کد ها توسط تیم داوری بررسی شده و در صورت تایید کد، مجوز حضور در رویداد صادر خواهد شد.
</p>
                                    <p>
                                        در طول مدت بررسی کد ها توسط تیم داوری، شرکت کنندگان با تیم داوری در تماس هستند و در صورت شناسایی ایراد در کد ها ، این موضوع توسط تیم داوری به شرکت کنندگان اطلاع داده می شود و تیم ها موظف هستند تا ایرادات کد های خود را برطرف کنند تا مجوز ورود به مسابقه را دریافت نمایند.
</p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h4>نحوه برگزاری مسابقات</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        تیم هایی که مجوز ورود به مسابقات را دریافت کردند می توانند در مرحله حضوری رویداد که در یک روز و به مدت 8 ساعت برگزار می شود شرکت نمایند.
                                    </p>
                                    <p>
                                        در روز برگزاری مسابقه در ابتدا کلیه کد های تایید شده در یک دفترچه چاپ شده و بین کلیه تیم های شرکت کننده توزیع می شود.
</p>
                                    <p>
                                        در این مرحله هر تیم هشت ساعت فرصت دارد تا خروجی کد های تیم دیگر را حدس بزند. شکستن هر کد برای تیم یک امتیاز در بر دارد و هر تیمی که تعداد بیشتری کد مبهم را شناسایی کند امتیاز بیشتری دریافت خواهد کرد. البته این نکته قابل ذکر است که در صورتی که کد یک تیم توسط تیم دیگری شکسته شود یک امتیاز منفی برای تیم صاحب کد در نظر گرفته می شود ( البته این امتیاز منفی فقط در اولین بار شکسته شدن کد مد نظر قرا گرفته می شود و اگر تیم های دیگر هم کد تیم را شناسایی کردند دیگر امتیاز منفی برای تیم در نظر گرفته نمی شود).
</p>
                                    <p>
                                        بین تیم هایی که برنامه هایشان از این نظر امتیاز مساوی دارند تیمی برنده است که تعداد کد بیشتری را شکافته باشد و در صورت مساوی بودن تعداد مسائل حل شده، تیمی برنده است که مجموع زمان حل مسائلش کمتر باشد.
 </p>
                                    <p>
                                        در مدت مسابقه، هر تیمی که خروجی یک برنامه را حدس بزند باید حدسش را با داور گروه در میان بگذارد تا داور درستی یا نادرستی حدس را اعلام کند. در صورت درست بودن پاسخ امتیاز برای تیم در نظر گرفته می شود و در صورت عدم پاسخ صحیح کد مورد به تیم برگردانده می شود تا مجددا برای شکستن کد اقدام نمایند. تیم ها بهتر است در هنگام اعلام خروجی یک برنامه دقت کنند زیرا به ازای هر حدس نادرست، مجموع زمان حل مسائلشان ده دقیقه افزوده میشود!
</p>
                                    <p>
                                        در کل مدت مسابقه امتیازات کسب شده توسط تیم ها بر روی یک نمایشگر بزرگ قابل مشاهده است و تیم ها رتبه خود را در این نمایشگر مشاهده می کنند. البته در یک ساعت پایانی مسابقه نمایشگر خاموش می شود تا نتیجه نهایی مسابقه در اختتامیه رویداد اعلام شود.
</p>
                                    <p>
                                        اعضای هر تیم در حین مسابقه حق مشورت با یکدیگر یا استفاده از انواع کتاب جزوه، ماشین حساب و خط کش و … را دارند اما استفاده از هرگونه کامپیوتر یا موبایل در حین مسابقه ممنوع میباشد.
</p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h4>مزایای شرکت در مسابقات برای برنامه نویسان</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                        <ul>
                                            <li>
                                                یادگیری
                                       <p>
                                                    بررسی کدهای مختلف، نوشتن کد جدید و ارتباط مستمر با تیم داوری، باعث افزایش سطح علمی و مهارت افراد می‌شود.
                                       </p>
                                            </li>
                                            <li>
                                                تمرین
                                       <p>
                                                    ارسال کدها مبهم برای تیم داوری، مشاوره و گرفتن تایید فرصتی را برای محک زدن توانایی افراد فراهم می‌آورد.
                                       </p>
                                            </li>
                                            <li>
                                                رقابت
                                       <p>
                                                    آزمون انتخابی و آزمون نهایی محل اصلی رقابت بین افراد برتر هستند و نشان‌دهنده مهارت افراد در برنامه‌نویسی می‌باشند.
                                       </p>
                                            </li>
                                            <li>
                                                استخدام در شرکت های معتبر
                                       <p>
                                                    پس از برگزاری مسابقات، برای تیم های برتر امکان استخدام در شرکت های معتبر فعال در حوزه فناوری اطلاعات که از برگزاری این رویداد حمایت کرده اند وجود دارد.
                                       </p>
                                            </li>
                                        </ul>
                                    </p>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
